import { SkipForward } from "lucide-react";

type IntroProps = {
  onDone: () => void;
};

export function Intro({ onDone }: IntroProps) {
  return (
    <section className="intro" aria-label="Intro aplikacji">
      <div className="intro__topline">
        <span>SNG Dispatch</span>
        <button className="icon-button icon-button--ghost" type="button" onClick={onDone} aria-label="Pomin intro">
          <SkipForward size={18} />
        </button>
      </div>

      <div className="intro__stage" onAnimationEnd={onDone}>
        <div className="intro__warehouse" />
        <div className="intro__light intro__light--left" />
        <div className="intro__light intro__light--right" />
        <div className="intro__road">
          <span />
          <span />
          <span />
        </div>

        <div className="intro-truck" aria-hidden="true">
          <div className="intro-truck__trailer">
            <div className="intro-truck__stripe" />
          </div>
          <div className="intro-truck__cab">
            <div className="intro-truck__window" />
            <div className="intro-truck__lamp" />
          </div>
          <div className="intro-truck__wheel intro-truck__wheel--rear"><span /></div>
          <div className="intro-truck__wheel intro-truck__wheel--front"><span /></div>
        </div>
        <div className="intro__wheel-close" aria-hidden="true">
          <span>SNG</span>
        </div>
      </div>
    </section>
  );
}
